// Transaction Officer Search

<template>
<section class="lms5100-container">

  <div class="lms5100 white border-main shadow-dark">
    <Ul class="crumbs text-charcoal mb-2">
      <li><sym-link to="/">Home</sym-link></li>
      <li><sym-link :to="getPortalPagePath()">Portal</sym-link></li>
      <li><span aria-current="page">Transaction Inquiry</span></li>
    </Ul>

    <div class="page-title lams curved mb-2">
      <h5 class="serif mb-0"><i class="fa fa-search fa-lg ml-1 mr-2"></i>Transaction Inquiry</h5>
    </div>

    <div class="favorites" v-show="isLoggedOn">
      <button type="button" class="primary-light border-main w-100 text-center shadow-soft mb-1" @click="openFavorites=!openFavorites" @mousedown="onButtonMouseDown" v-show="hasFavorites"><i class="fa fa-heart-o fa-lg mr-2"></i>Favorites</button>

      <sym-collapse v-model="openFavorites">
        <table>
          <thead>
            <tr class="whitesmoke">
              <th class="w-40">Region</th>
              <!-- <th class="w-30">Transaction</th> -->
              <th class="w-30">Transaction No.</th>
              <th class="w-30" colspan="2"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fav, index) in favorites" :key="index">
              <td class="w-40">{{ fav.regionFullName }}</td>
              <td class="w-30">{{ fav.transactionId }}</td>
              <td class="w-15 px-1 py-0"><button type="button" class="lams-light border-main w-100 sm-1 text-center" title="Open" @click="onTransactionClick(fav)" @mousedown="onButtonMouseDown"><i class="fa fa-folder-open-o fa-lg"></i> </button></td>
              <td class="w-15 px-1 py-0"><button type="button" class="primary-light border-main w-100 sm-1 text-center" title="Delete favorite" @click="onRemoveFavorite(fav)" @mousedown="onButtonMouseDown"><i class="fa fa-times fa-lg"></i></button></td>
            </tr>

          </tbody>
        </table>
      </sym-collapse>
    </div>
 
    
    <div class="controls lams-light curved-bottom mb-3 shadow-light border-main">
      <!-- <sym-combo plain vertical align="bottom" v-model="regionId" caption="Region"  display-field="regionFullName" :datasource="regions" @changing="onRegionIdChanging" ></sym-combo> -->
      <sym-combo plain vertical align="bottom" v-model="regionId" caption="Region" display-field="regionFullName" :datasource="regions" @changing="onRegionIdChanging"></sym-combo>

      <!-- <sym-combo plain vertical align="bottom" v-model="provinceId" caption="Province"  display-field="provinceName" :datasource="provinces" @changed="onProvinceIdChanged()"></sym-combo>
      <sym-combo plain vertical align="bottom" v-model="municipalityId" caption="Municipality" display-field="municipalityName" :datasource="municipalities" @changed="onMunicipalityIdChanged()"></sym-combo>
      <sym-combo plain vertical align="bottom" v-model="barangayId" caption="Barangay"  display-field="barangayName" :datasource="barangays"></sym-combo> -->
      <sym-text plain vertical align="bottom" v-model="transactionId" caption="Transaction Number" ></sym-text>
      <sym-text plain vertical align="bottom" v-model="lotNumber" caption="Lot Number" ></sym-text>
      <sym-text plain vertical align="bottom" v-model="clientName" caption="Client Name" ></sym-text>
      
      <!-- <sym-text plain vertical align="bottom" v-model="surveyPlan"  caption="Survey Plan" ></sym-text> -->
    </div>

    <div class="d-flex">
      <button type="button" class="text-center info lg-2 w-100 mr-2" :disabled="!canSearch" @click="onSearch"><i class="fa fa-search fa-lg mr-2"></i><br><p class="mb-0">Search</p></button>
      <button type="button" class="text-center warning lg-2 w-100" @click="searchAgain"><i class="fa fa-undo mr-2"></i>Reset</button>
    </div>

    <div class="d-flex justify-center align-items-center danger-light p-2 mt-4 curved" v-if="transactions && transactions.length === 0">
      <span class="lg-2"><i class="fa fa-info-circle fa-lg mr-2"></i>No records found.</span>
      <button type="button" class="info shadow-dark ml-3 lg-2" @click="searchAgain"><i class="fa fa-undo mr-2"></i>Search Again</button>
    </div>

    <div class="lg-3 d-flex justify-center align-items-center p-2 curved" v-if="transactions && transactions.length !== 0">
      <span class="lg-3"><b>{{ transactionCount }} record/s found.</b></span>
    </div>

    <sym-pager
      v-model="currentPage"
      :totalPages="totalPages"
      align="center"
      @change="onPageChange"
      @pager:rangeChanged="rangeStart = $event"
      v-if="currentPage && transactions && transactions.length > 0"
      class="lams-light border-main curved mb-3 pt-2 px-2"
    >
    </sym-pager>

    <div class="table-scroll-wrapper" v-show="transactions && transactions.length">
      <table class="table-scroll">
        <thead class="info-light">
          <tr class="text-charcoal">
            <th class="w-10">Transaction ID</th>
            <th class="w-20">Client Name</th>
            <th class="w-30">Lot Number</th>
            <th class="w-30">Location</th>
          </tr>

        </thead>

        <tbody class="white text-charcoal">
          <tr v-for="p in transactions" :key="p.transactionId" @click="onTransactionClick(p)">
            <td class="w-10">{{ p.transactionId }}</td>
            <td class="w-20">{{ p.clientName }}</td>
            <td class="w-30">{{ p.requestedLot }}</td>
            <td class="w-30">{{ p.requestedLocation }}</td>
            
          </tr>
        </tbody>
      </table>
    </div>

    <sym-pager
      v-model="currentPage"
      :totalPages="totalPages"
      align="center"
      @change="onPageChange"
      @pager:rangeChanged="rangeStart = $event"
      v-if="currentPage && transactions && transactions.length > 0"
      class="lams-light border-main curved mt-3 pt-2 px-2"
    >
    </sym-pager>

    <button type="button" class="primary text-center w-100 lg-1 shadow mt-3 mb-2" @click="goBack()"><i class="fa fa-arrow-left mr-2"></i> Back</button>

  </div>

</section>
</template>

<script>

import {
  get,
  encode,
  ajax
} from '../../js/http';

import
  * as lams
from '../../js/lams';

import
  PageBase
from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'lms5100',

  data () {
    return {
      regionId: 0,
      regions: [],
      // provinceId: 0,
      // provinces: [],
      // municipalityId: 0,
      // municipalities: [],
      // barangayId: 0,
      // barangays: [],
      transactionId: '',
      lotNumber: '',
      clientName: '',
      // claimant: '',
      // surveyPlan: '',
      accountCode: '',
      transactions: null,
      favorites: [],
      openFavorites: false,
      transactionCount: -1,
      currentPage: 1,
      totalPages: 0
    };
  },

  computed: {

    isLoggedOn () {
      return this.accountCode > '';
    },
    
    canSearch () {
      const me = this;

      if (me.regions.length === 0) {
        return false;
      }

      return me.regionId ;
    },

    hasFavorites () {
      // console.log(isLoggedOn);
      // console.log(this.favorites.length);
      return this.favorites.length;
    },

  },

  methods: {

    getTargetPath () {
      const
        me = this,
        q = {};

      if (me.regionId) {
        q.regionId = me.regionId;
      }

      if (me.transactionId) {
        q.transactionId = me.transactionId;
      }

      if (me.lotNumber) {
        q.lotNumber = me.lotNumber;
      }
    
      if (me.clientName) {
        q.clientName = me.clientName;
      }
  
      q.page = me.currentPage;

      return {
        name: me.$options.name,
        query: q
      };
    },

    syncValues (p, q) {
      const me = this;

      if ('regionId' in q && me.core.isInteger(q.regionId)) {
        me.regionId = parseInt(q.regionId);
      } else {
        me.regionId = 0;
      }

      if ('transactionId' in q) {
        me.transactionId = q.transactionId;
      } else {
        me.transactionId= '';
      }

      if ('lotNumber' in q) {
        me.lotNumber = q.lotNumber;
      } else {
        me.lotNumber = '';
      }

      if ('clientName' in q) {
        me.clientName = q.clientName;
      } else {
        me.clientName = '';
      }


      if ('page' in q && me.core.isInteger(q.page)) {
        me.currentPage = parseInt(q.page);
      }
    },

    loadData () {
      const me = this;

      if (!me.regionId) {
        return;
      }

      let wait = me.wait();

      me.getTransactionCount()
        .then( count => {
          if (!count) {
            return [];
          }
          me.transactionCount = count;
          me.totalPages = Math.ceil(me.transactionCount / me.itemsPerPage);
          return me.getTransactions();
        })
        .then( transactions => {
          me.stopWait(wait);
          me.transactions = transactions;
          me.replaceUrl();
          me.openFavorites = false;
        })
        .catch( fault => {
          me.stopWait(wait);
          me.showFault(fault);
        });
    },

    onSearch () {
      const me = this;
      // console.log(me.clientName.isEmpty());  
      // if (me.clientName = null) {
      //   me.advice.fault('Fill in the required fields (marked in red).', { duration: 4 } )
      //   return;
      // }


      me.currentPage = 1;
      me.loadData();
    },

    onPageChange (page) {
      const me = this;

      me.currentPage = page;
      me.reload();
    },


    onRegionIdChanging (e) {
      const me = this;

      let regionInfo = me.regions.find( obj => obj.regionId === e.proposedValue );
      e.message = `Region '${regionInfo.regionFullName}' is offline.`;

      if (!regionInfo.apiHostAddress && regionInfo.regionId) {
        e.preventDefault();
        return;
      }

      if (e.proposedValue) {
        e.callback = me.regionIdCallback;
      }

    },

    regionIdCallback (e) {
      const
        me = this,
        wait = me.wait();

      return me.getLinkStatus(e.proposedValue).then(
        statusCode => {
          me.stopWait(wait);

          let isOnline = (statusCode === 200);
          return isOnline;
        },
        () => {
          me.stopWait(wait);
          return false;
        }
      );

    },
    // onRegionIdChanged () {
    //   const
    //     me = this,
    //     wait = me.wait();

    //   // me.provinces = [];
    //   // me.municipalities = [];
    //   // me.barangays = [];

    //   me.getProvinces().then(
    //     data => {
    //       me.stopWait(wait);
    //       me.provinces = data;

    //       if (me.provinces.length) {
    //         me.provinces.unshift({ provinceId: 0, provinceName: '--- Select Province ---' });
    //         me.setFocus('provinceId');
    //       }

    //     },
    //     fault => {
    //       me.stopWait(wait);
    //       me.showFault(fault);
    //     }
    //   )
    // },

    getTransactionCount () {
      const me = this

      let q = this.getSearchQuery();

      if (q) {
        return get('api/rgn/' + me.regionId + '/transaction-search/count?' + q);
      } else {
        return get('api/rgn/' + me.regionId + '/transaction-search/count');
      }
    },

    getTransactions () {
      const me = this;

      let q = 'ipp=' + (me.itemsPerPage || 10);
      q = q + '&page=' + (me.query.page || 1);

      let sq = me.getSearchQuery();
      if (sq) {
        return get('api/rgn/' + me.regionId + '/transaction-search?' + me.getSearchQuery() + '&' + q);
      } else {
        return get('api/rgn/' + me.regionId + '/transaction-search?' + q);
      }
    },

   
    getFavorites () {
      return get('api/accounts/' + this.accountCode + '/regions-transaction');
    },

    removeFavorite (fav) {
      const options = {
        method: 'DELETE'
      };

      let q = 'regionId=' + fav.regionId + '&transactionId=' + fav.transactionId;

      return ajax('api/accounts/' + this.accountCode + '/region-transaction?' + q, options);
    },
    
    
    onRemoveFavorite (fav) {
      const
        me = this,
        index = me.favorites.findIndex(obj => obj.regionId === fav.regionId && obj.transactionId === fav.transactionId);

      me.removeFavorite(fav).then(
        () => {
          if (index > -1) {
            me.favorites.splice(index, 1);
          }
          me.openFavorites = me.favorites.length > 0;
        },
        fault => {
          me.showFault(fault);
        }
      )

    },

    onButtonMouseDown (e) {
      e.preventDefault();
    },

   
    onOpenFavorite (fav) {
      const me = this;
      
      me.getLinkStatus(fav.regionId).then(
        statusCode => {
          if (statusCode !== 200) {
            me.advice.fault(`Region '${fav.regionFullName}' is offline.`);
            return;
          }
          me.openFavorites = false;
          me.regionId = fav.regionId;
          
          me.transactionId = fav.transactionId.toString();
          // me.reload();
          me.loadData();
        },
        () => {
        }
      );

    },
 
    
    getSearchQuery () {
      const me = this;
      let q = '';

      // if (me.regionId) {
      //   if (q) { q += '&'; }
      //   q += 'regionId=' + me.regionId;
      // }

      if (me.transactionId) {
        if (q) { q += '&'; }
        q += 'transactionId=' + encode(me.transactionId);
      }

      if (me.lotNumber) {
        if (q) { q += '&'; }
        q += 'lotNumber=' + encode(me.lotNumber);
      }

      if (me.clientName) {
        if (q) { q += '&'; }
        q += 'clientName=' + encode(me.clientName);
      }


      return q;
    },

    onTransactionClick (transaction) {
      const me = this;
      
      let route = {
        name: 'lms3300',
        query: {
          regionId: me.regionId,
          transactionId: transaction.transactionId.toString()
        }
      };
      me.go(route);
    },

    //API CALLS


    getLinkStatus (regionId) {
      return get('api/regions/' + regionId + '/link-status');
    },

    searchAgain () {
      const me = this;

      me.transactions = null;
      me.transactionId = '';//'0;
      me.lotNumber = '';
      me.clientName = '';
      
      // me.claimant = '';
  
      me.regionId = 0;

      me.setFocus('regionId');
    },

    getPortalPagePath () {
      let
        page = '',
        typeId = this.accountTypeId;

      if (typeId === 1) { page = 'lms1010'; }
      if (typeId === 2) { page = 'lms1020'; }
      if (typeId === 3) { page = 'lms1030'; }
      if (typeId === 4) { page = 'lms1040'; }
      if (page) {
        return this.sym.getPath(page);
      }
      return '/';
    },

  },

  created () {
    this.itemsPerPage = 10;
    this.accountTypeId = 0;
  },

  mounted () {
    const me = this;

    me.accountCode = me.sym.userInfo.accountCode;
    me.accountTypeId = me.sym.userInfo.accountTypeId;

    me.transactions = null;
    me.currentPage = 1;

    me.setFocus('regionId');
    me.regions = lams.getRegionList().filter(o => o.apiHostAddress);
    me.regions.unshift(
      { regionId: 0, regionFullName: '--- Select Region ---' }
    )


    if (me.isLoggedOn) {
      
      me.getFavorites()
        .then(list => {
          me.favorites = list;
        })
        .catch(fault => {
          me.showFault(fault);
        })
    }

    me.syncValues(me.params, me.query);

    if (me.regionId !== 0) {
      me.loadData();
      // me.onRegionIdChanged();
      // me.onProvinceIdChanged();
      // me.onMunicipalityIdChanged();
    }

    me.$nextTick( () => {
      setTimeout(() => {
        me.setFocus('regionId');
      }, 200);
    });

  },

  beforeRouteUpdate (to, from, next) {
    this.syncValues(to.params, to.query);
    next();

    if (Object.keys(from.query).length) {
      this.loadData();
    }
  }

}

</script>

<style scoped>

.lms5100-container {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}

.lms5100 {
  width: 80%;
  padding: 2rem;
  border-radius: .375rem;
}

.page-title {
  padding: .875rem;
}

.controls {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: .5rem;
  column-gap: 1rem;
  padding: 1rem;
  padding-bottom: 1.5rem;
}

.controls >>> .form-control {
  margin-bottom: 2px;
}

.controls >>> .input-tag {
  padding-bottom: 2px;
  margin-left: 2px;
}

.table-scroll-wrapper {
  overflow-x: auto;
}

.table-scroll {
  /* display: block; */
  /* overflow-x: auto; */
  white-space: nowrap;
  width: -moz-available;
  width: -webkit-fill-available;
}

.table-scroll tbody tr:hover {
  background-color: ivory;
  box-shadow: 2px 2px 16px 8px rgba(48, 48, 48, .3);
  cursor: pointer;
  transition: all .3s ease-in-out;
}

td, th {
  vertical-align: top;
}

@media (max-width: 1024px) {
  .lms5100 {
    width: 90%;
    padding: 2rem;
  }
  .controls {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .controls {
    grid-template-columns: repeat(1, 1fr);
    gap: .25rem;
  }
}

@media (max-width: 640px) {
  .lms5100-container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .lms5100 {
    width: 100%;
    padding: 1rem;
    border-radius: 0;
  }
}

@media (max-width: 420px) {
  .lms5100 {
    padding: .5rem;
  }
}

</style>